import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import SettingsList from "./SettingsList";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import fetchRoute from "utils/routes";

export class CreateMenuDropdown extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showAutomationTab: false,
			list: [
				{
					src: "/assets/images/createMenu/Email.svg",
					path: "/campaigns/create",
					title: <Translate value="app-menu-create-campaign" />,
				},
				{
					src: "/assets/images/createMenu/icon-lightning.svg",
					path: "/automations/create",
					title: <Translate value="app-menu-create-automations" />,
				},
				{
					src: "/assets/images/createMenu/Contact.svg",
					path: fetchRoute("addSingleContact", {
						listId: props.selectedList?.id ? props.selectedList?.id : "default",
					}),
					title: <Translate value="app-menu-create-contact" />,
				},
				{
					src: "/assets/images/createMenu/List.svg",
					path: "/forms/create",
					title: <Translate value="app-menu-create-form" />,
				},
			],
		};

		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.setRef = this.setRef.bind(this);
		this.redirectToPath = this.redirectToPath.bind(this);
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			this.props.changeStatus();
		}
	}

	handleClickOutside(event) {
		if (
			this.wrapperRef &&
			!this.wrapperRef.contains(event.target) &&
			this.props.createRef &&
			!this.props.createRef.contains(event.target)
		) {
			this.props.changeStatus();
		}
	}

	setRef(node) {
		this.wrapperRef = node;
	}

	redirectToPath(item) {
		if (item.action) {
			item.action();
			return;
		}

		if (item.type === "link") {
			window.location.href = item.path;
		} else {
			this.props.history.push({
				pathname:
					item.path === "/account/subscriptions/create" &&
					this.props.subscriptions != null &&
					this.props.subscriptions.length === 0
						? "/account/subscriptions/subscription-step-1"
						: item.path,
				state: {
					from: this.props.location.pathname,
				},
			});
		}
	}

	render() {
		let dropDown = null;
		let list = this.state.list.map((element, index) => {
			return (
				<div
					className="create-list-item"
					key={`create-list-${index}`}
					onClick={() => this.redirectToPath(element)}
				>
					<SettingsList
						{...this.props}
						listItem={element}
						key={`settings-item-${index}`}
					/>
					<img src={element.src} />
				</div>
			);
		});

		dropDown = (
			<div className="drop-down" ref={this.setRef}>
				{list}
			</div>
		);

		return <div className="dropdown-container">{dropDown}</div>;
	}
}

export default withRouter(
	connect(
		(state) => {
			return {
				subscriptions: state.subscriptions.subscriptions,
				selectedList: state.contacts.selectedList,
			};
		},
		(dispatch) => bindActionCreators({}, dispatch)
	)(CreateMenuDropdown)
);
